import { Component, OnInit, signal, WritableSignal, ChangeDetectionStrategy, inject } from '@angular/core';
import { Icons } from '../../../util/Icons';
import { MatIconModule } from '@angular/material/icon';
import { AraIcon } from '../../../util/AraIcon';
import { MatDialogContent } from '@angular/material/dialog';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { SnackbarService } from '../../../services/snackbar.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Config } from '../../../config';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'vex-icon-tester',
	imports: [MatIconModule, MatDialogContent, CdkCopyToClipboard, ReactiveFormsModule, MatButtonModule, MatFormFieldModule, MatInputModule, TranslocoModule],
	templateUrl: './icon-tester.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './icon-tester.component.scss',
})
export class IconTesterComponent implements OnInit {
	transloco = inject(TranslocoService);
	snackbar = inject(SnackbarService);
	icons = inject(Icons);

	allIcons: WritableSignal<AraIcon[]> = signal([]);
	duplicates: WritableSignal<AraIcon[]> = signal([]);
	searchValue = new FormControl();
	searchTimeoutDelay = Config.SEARCH_DELAY;

	constructor() {
		const icons = this.icons;

		this.allIcons.set(icons.getAllIcons());
		this.duplicates.set(icons.findDuplicates());
	}

	ngOnInit() {
		this.searchValue.valueChanges.pipe(debounceTime(this.searchTimeoutDelay)).subscribe((filterValue) => {
			this.applyFilter(filterValue);
		});
	}

	applyFilter(filterValue: string) {
		if (!filterValue) {
			this.allIcons.set(this.icons.getAllIcons());
			return;
		}
		this.allIcons.set(
			this.allIcons().filter((value) => {
				return (
					value.label.toLowerCase().includes(filterValue.toLowerCase()) ||
					value.path.toLowerCase().includes(filterValue.toLowerCase()) ||
					value.origin.toLowerCase().includes(filterValue.toLowerCase())
				);
			})
		);
	}

	copyLabelToClipboard(value) {
		this.snackbar.success(this.transloco.translate('settings.devSettings.frontendTools.copiedToClipboard').replace('%', value));
	}
}
